import io from "socket.io-client";

class SocketService {
  constructor() {
    this.socket = null;
    this.listeners = {};
  }

  connect() {
    if (this.socket) return;

    // Connect to the same URL as the backend
    const baseUrl = "http://localhost:1337";
    this.socket = io(baseUrl);

    this.socket.on("connect", () => {
      console.log("Socket connected:", this.socket.id);
    });

    this.socket.on("disconnect", () => {
      console.log("Socket disconnected");
    });

    this.socket.on("error", (error) => {
      console.error("Socket error:", error);
    });
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }

  subscribeToVerification(accountId) {
    if (!this.socket) this.connect();
    if (!accountId) return;

    console.log(
      `Subscribing to verification updates for account: ${accountId}`
    );
    this.socket.emit("subscribe:verification", accountId);

    // Setup listeners for verification events
    this.setupVerificationListeners();
  }

  unsubscribeFromVerification(accountId) {
    if (!this.socket || !accountId) return;

    console.log(
      `Unsubscribing from verification updates for account: ${accountId}`
    );
    this.socket.emit("unsubscribe:verification", accountId);
  }

  setupVerificationListeners() {
    // Onboarding updates
    this.socket.on("verification:onboarding_update", (data) => {
      if (this.listeners.onboardingUpdate) {
        this.listeners.onboardingUpdate(data);
      }
    });

    // AML updates
    this.socket.on("verification:aml_update", (data) => {
      if (this.listeners.amlUpdate) {
        this.listeners.amlUpdate(data);
      }
    });

    // Onboarding updates
    this.socket.on("verification:incorporation_update", (data) => {
      if (this.listeners.incorporationUpdate) {
        this.listeners.incorporationUpdate(data);
      }
    });
  }

  onOnboardingUpdate(callback) {
    this.listeners.onboardingUpdate = callback;
  }

  onAmlUpdate(callback) {
    this.listeners.amlUpdate = callback;
  }

  onIncorporationUpdate(callback) {
    console.log("On incorporation update");
    this.listeners.incorporationUpdate = callback;
  }

  removeAllListeners() {
    if (!this.socket) return;

    this.socket.off("verification:onboarding_update");
    this.socket.off("verification:aml_update");
    this.socket.off("verification:incorporation_update");
    this.listeners = {};
  }
}

// Create a singleton instance
const socketService = new SocketService();
export default socketService;
